export default {
    BranchMap: {
        route_header_title: 'Branches',
        branch_detail_action_button: 'Show All Branches',
        branch_detail_layout_right_button: 'Select Branch',
        branch_list_layout_right_button: 'Select Branch',
        branch_list_bottom_sheet_header: 'BRANCHES',
        branch_list_bottom_sheet_header_button: 'Show on Map',
        location_permission_toast_message:
            'Would you like to see nearby branches\nby granting location permission?',
        location_provider_error_toast_message:
            'Location setting on the device is turned off',
        location_permission_toast_chip_label: 'Allow',
    },
    Packages: {
        right_info_title: 'Subscriptions/Packages',
        right_info_description:
            'On the Packages screen you can browse the packages and subscriptions on sale, search them, and filter by branch or type. Open a package to see the benefits it includes and the branches it is valid at.',
        route_header_title: 'Subscriptions/Packages',
        content_header_title: 'Subscriptions/Packages',
        content_header_description:
            'Explore subscription and package options, buy now',
        search_field_placeholder: 'Search subscription/package',
        category_chip_all: 'All',
        category_chip_subscription: 'Subscriptions',
        category_chip_package: 'Packages',
        branch_filter_chip_label: '{{branchName}}',
        branch_sheet_title: 'Select Branch',
        branch_sheet_description: 'Filter packages by branch.',
        branch_sheet_clear_button: 'Clear Filter',
        branch_sheet_empty_title: 'No Branch Found',
        branch_sheet_empty_description: 'No branch was found for this company.',
        empty_sheet_title: 'No Package Found',
        empty_sheet_description:
            'No subscription or package found for this company',
        empty_sheet_description_filtered:
            'No package matches your search. Try changing the filters.',
    },
    PackageDetails: {
        search_field_placeholder: 'Search benefit',
        sheet_title: 'Package Details',
        sheet_description: 'Review the contents and benefits of the package.',
        sheet_title_subscription: 'Subscription Details',
        sheet_description_subscription:
            'Review the contents and benefits of the subscription.',
        benefits_section_title: 'Benefits',
        filter_limited: 'Limited',
        filter_limitless: 'Unlimited',
        filter_out_of_scope: 'Out of Scope',
        branch_section_title: 'Branch',
        branch_section_placeholder: 'Select branch',
        branch_section_change_chip_label: 'Change',
        select_branch_error_toast_message:
            'You need to select a branch to continue.',
        footer_section_submit_button_label: 'Continue',
        empty_benefits_title: 'No Benefit Found',
        empty_benefits_description:
            'No benefit matches this filter. Try another one.',
    },
    PackagePayment: {
        right_info_title: 'Purchase',
        right_info_description:
            'Here you can set the start date and quantity of the package and continue to payment. Your wallet balance is used at the payment step; if it is not enough you can top it up.',
        route_header_title: 'Purchase',
        content_header_title: 'Purchase Summary',
        content_header_description: 'Check the details and proceed to payment.',
        details_section_title: 'Package',
        details_section_branch_label: 'Branch',
        details_section_details_chip_label: 'Details',
        select_date_section_title: 'Start',
        select_date_section_when_first_used_toast_message:
            'The package starts on first use.',
        select_date_section_immediately_toast_message:
            'The package starts right after purchase.',
        select_date_section_now_label: 'Start now ({{today}})',
        select_date_section_planed_label: 'Scheduled date ({{formattedDate}})',
        select_date_section_change_chip_label: 'Change',
        quantity_section_title: 'Quantity',
        submit_button_label: 'Proceed to Payment',
        action_button_cancel_title: 'Cancel',
        cancel_alert_title: 'Leave the purchase?',
        cancel_alert_message: 'The details you entered will be lost.',
        cancel_alert_approve_button: 'Leave',
        cancel_alert_cancel_button: 'Continue',
        warning_alert_title: 'Warning',
        warning_alert_reject: 'OK',
        toast_error_message: 'The purchase could not be completed. Try again.',
    },
    PackageUsageHistory: {
        content_header_title: 'Usage History',
        content_header_description:
            'View your spending with subscriptions and packages',
        search_field_placeholder: 'Search',
        filter_button_label: 'Filter',
        empty_sheet_title: 'No Transactions Found',
        empty_sheet_description:
            'You have no spending made with a subscription or package',
        category_chip_subscription: 'Subscription',
        category_chip_package: 'Package',
    },
    PackageUsageHistoryDetail: {
        content_header_title: 'Transaction Details',
        content_header_description:
            'You can easily access all transaction details here',
        transaction_details: 'TRANSACTION DETAILS',
        branch_details: 'BRANCH DETAILS',
        additional_details: 'ADDITIONAL DETAILS',
        process_type: 'Transaction Type',
        package_usage: 'Package Usage',
        subscription_usage: 'Subscription Usage',
        spent_amount: 'Spent Amount',
        covered_by_package: 'Covered by Package',
        covered_by_subscription: 'Subscription Discount',
        paid_amount: 'Paid Amount',
        date: 'Date',
        branch_name: 'Branch Name',
        description: 'Description',
        package: 'Package',
        subscription: 'Subscription',
        package_name: 'Package Name',
        tag_qr_name: 'Tag QR Name',
    },
    PackageUsageHistoryFilter: {
        content_header_title: 'Filter Usages',
        content_header_description:
            'Apply the filters you need and reach the results easily',
        package_label: 'Package/Subscription',
        package_placeholder: 'Select a package or subscription',
        package_step_title: 'Select Package/Subscription',
        package_step_description:
            'Select the package or subscription whose usages you want to see',
        package_clear_button: 'Clear Selection',
        package_empty_title: 'No Packages Found',
        package_empty_description: 'No active subscription or package found',
        categories: 'CATEGORY',
        category_chip_all: 'All',
        category_chip_subscription: 'Subscription',
        category_chip_package: 'Package',
        date: 'DATE RANGE',
        start_date_label: 'Start Date',
        end_date_label: 'End Date',
        date_time_placeholder: 'e.g., 07/07/2023',
        submit: 'Show Results',
    },
    PurchasedPackages: {
        category_chip_usage_history: 'Usage History',
        card_detail_button_label: 'Details',
        right_info_title: 'Subscriptions/Packages',
        right_info_description:
            'This screen lists the packages and subscriptions you own, along with your remaining usage rights and validity dates. Open a card to review the details or cancel your subscription.',
        route_header_title: 'Subscriptions/Packages',
        content_header_title: 'Subscriptions/Packages',
        content_header_description:
            'You can view your subscriptions and packages here.',
        category_chip_all: 'All',
        category_chip_subscription: 'Subscription',
        category_chip_package: 'Package',
        empty_sheet_title: 'No Subscription Found',
        empty_sheet_description: 'No active subscription or package found.',
        empty_sheet_subscription_description: 'No active subscription found.',
        empty_sheet_package_description: 'No active package found.',
    },
    PurchasedPackageDetails: {
        sheet_title: 'Subscription Details',
        sheet_title_package: 'Package Details',
        sheet_description:
            'Review the usages and details of your subscription.',
        sheet_description_package:
            'Review the usages and details of your package.',
        benefits_section_title: 'PACKAGE USAGES',
        participation_title: 'Detailed Information',
        subscription_cancel_button_title: 'Cancel Subscription',
        package_cancel_button_title: 'Cancel Package',
        subscription_general_info_title: 'GENERAL INFORMATION',
        subscription_general_info_total_earned_discount_title:
            'Total Earned Discount',
        subscription_general_info_start_date_title: 'Start Date',
        subscription_general_info_end_date_title: 'End Date',
        subscription_general_info_total_usage_count_title: 'Total Usage',
        empty_benefits_title: 'No Usage Found',
        empty_benefits_description:
            'No usage matches this filter. Try another one.',
    },
    PurchasedPackageCancel: {
        title: 'Subscription Cancellation Summary',
        title_package: 'Package Cancellation Summary',
        description: 'You can access the subscription details below',
        description_package: 'You can access the package details below',
        subscription_subtitle: 'SUBSCRIPTION DETAILS',
        package_subtitle: 'PACKAGE DETAILS',
        subscription_amount_label: 'Refundable Amount',
        subscription_usage_date_label: 'Number of Used Days',
        subscription_remaining_label: 'Total Days',
        date_label: 'days',
        no_refund_description:
            'No refund will be issued for this subscription. Cancelling ends your remaining usage rights.',
        no_refund_description_package:
            'No refund will be issued for this package. Cancelling ends your remaining usage rights.',
        cancel_button_title: 'Cancel',
        close_button_title: 'Close',
        alert_provider_success_message: 'Subscription cancelled successfully',
        alert_provider_success_message_package:
            'Package cancelled successfully',
        alert_provider_success_message_description:
            'You can check the details of the cancellation process by reviewing the wallet transactions',
        alert_provider_success_message_description_package:
            'You can check the details of the cancellation process by reviewing the wallet transactions',
        alert_provider_success_message_button: 'OK',
        toast_error_message:
            'The cancellation could not be completed. Try again.',
    },
    utils: {
        Package: {
            period_daily: 'Daily',
            period_weekly: 'Weekly',
            period_monthly: 'Monthly',
            limit_unlimited_label: 'Unlimited',
            limit_remaining_usage_label: 'Remaining Usage',
            limit_remaining_label: 'Remaining',
            status_active: 'Active',
            status_upcoming: 'Not Started',
            status_expired: 'Expired',
            benefit_description:
                'In addition to usage rights, you can benefit from the {{name}} service {{limit}} times.',
            benefit_unlimited_description:
                'In addition to usage rights, you can benefit from the {{name}} service an unlimited number of times.',
            benefit_out_of_scope_description:
                'You cannot benefit from the {{name}} service as it is not included in this package.',
        },
    },
}
